var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content account-authy" },
    [
      _c(
        "div",
        { staticClass: "verTitles" },
        [
          _c(
            "div",
            {
              staticClass: "verTextContainer",
              class: {
                accountSummaryFlow: _vm.accountSummaryFlow,
                "flex-grow-center": true
              }
            },
            [
              _c("div", { staticClass: "titles" }, [
                _c("p", { staticClass: "guidedTitle" }, [
                  _vm._v(
                    _vm._s(_vm.$t("Account.Authentication.2fa.Authentication"))
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Account.Authentication.2fa.AuthenticationByApp")
                    )
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "v-icon",
            {
              staticClass: "close",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.closeAutyPopup()
                }
              }
            },
            [_vm._v("close")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.formSubmitSppiner ? _c("div", [_c("circle-loader")], 1) : _vm._e(),
      _vm._v(" "),
      !_vm.formSubmitSppiner
        ? _c("div", [
            _vm.createTotpError
              ? _c("div", { staticClass: "flex-grow-center" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "Account.Authentication.2fa.Authentication.QR.Creation.NotCreated"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.createTotp()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Account.Authentication.2fa.Authentication.QR.Creation.TryAgain"
                          )
                        )
                      )
                    ]
                  )
                ])
              : _c("div", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.helpVisible,
                          expression: "!helpVisible"
                        }
                      ],
                      staticClass: "help gray-box",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.showHelp()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "flex-grow-center" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Authentication.2fa.Authentication.Help"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-icon", { staticClass: "chevron_down" }, [
                        _vm._v("expand_more")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.helpVisible,
                          expression: "helpVisible"
                        }
                      ],
                      staticClass: "help gray-box",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.hideHelp()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "flex-grow-center" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Authentication.2fa.Authentication.Help"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-icon", { staticClass: "chevron_up" }, [
                        _vm._v("expand_less")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.helpVisible
                    ? _c("div", {
                        staticClass: "help-text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "Account.Authentication.2fa.Authentication.Help.Text"
                            )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.totpUri
                    ? _c(
                        "div",
                        { staticClass: "qrcode-box" },
                        [
                          _c("vue-qr", {
                            attrs: { text: _vm.totpUri, size: 200 }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center margin-b-10 font-bold" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Authentication.2fa.Authentication.ProblemWithQRCode"
                            )
                          )
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Authentication.2fa.Authentication.CopyQRCode"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { ref: "code", staticClass: "key-box" }, [
                    _c("span", [_vm._v(_vm._s(_vm.totpSecret))]),
                    _c("br"),
                    _vm._v(" "),
                    !_vm.copied
                      ? _c("a", { on: { click: _vm.copyCode } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.Authentication.2fa.Authentication.CopyQRCodeToClipboard"
                              )
                            )
                          )
                        ])
                      : _c("a", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.Authentication.2fa.Authentication.QRCodeCopiedToClipboard"
                              )
                            )
                          )
                        ]),
                    _vm._v(" "),
                    _c("input", { attrs: { type: "button", id: "copyBtn" } })
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "enter-digits-pin" }, [
                        _c("label", { staticClass: "font-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.Authentication.2fa.Authentication.EnterPin"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.pinCode,
                              expression: "pinCode",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: {
                            autocomplete: "off",
                            name: "qrCode",
                            maxlength: _vm.pinCodeLengthFromUri
                          },
                          domProps: { value: _vm.pinCode },
                          on: {
                            focusout: function($event) {
                              !_vm.qrCode
                                ? (_vm.errorMessages.pin = true)
                                : (_vm.errorMessages.pin = false)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pinCode = $event.target.value.trim()
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _vm.errorMessages.pin
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              attrs: { id: "err_msg_phone_missing" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "Account.VerificationByPin.ErrorMsg.PinCode"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errorMessages.pinNonDigit
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              attrs: { id: "err_msg_phone_not_digit" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "Account.VerificationByPin.ErrorMsg.PinCodeNonDigit"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errorMessages.pinLength
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              attrs: { id: "err_msg_phone_length" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "Account.VerificationByPin.ErrorMsg.PinCodeApp.Length",
                                    {
                                      pinCodeAppLength: _vm.pinCodeLengthFromUri
                                    }
                                  )
                                )
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "verify-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Authentication.2fa.Authentication.FormAuthentication"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-verify",
                          attrs: { color: "success", "x-large": "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.verify()
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.Authentication.2fa.Authentication.Verify"
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ProcessingDialog",
        {
          attrs: {
            isDialogPersistent: true,
            isProcessing: _vm.isProcessing,
            isSuccess: !_vm.transactionError,
            processingTitle: _vm.$t(
              "Account.Authentication.2fa.Dialog.Processing.Title"
            ),
            processingText: _vm.$t(
              "Account.Authentication.2fa.Dialog.Processing.Text"
            ),
            successTitle: _vm.$t(
              "Account.Authentication.2fa.Dialog.Success.Title"
            ),
            successText: _vm.$t(
              "Account.Authentication.2fa.Dialog.Success.Text"
            ),
            errorTitle: _vm.$t("Account.Authentication.2fa.Dialog.Error.Title"),
            closeBtnText: _vm.$t(
              "ProcessingDialog.Authentication.2fa.CloseButtonText"
            )
          },
          on: { close: _vm.closeAuthyDialog },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
            _vm.brandKey !== "sb"
              ? _c(
                  "p",
                  { staticClass: "generic-icon-note" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-1", attrs: { color: "error" } },
                      [_vm._v("error")]
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.Authentication.2fa.Dialog.Error.Text")
                        )
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "response-error" }, [
              _vm._v(_vm._s(_vm.transactionError))
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "Account.Authentication.2fa.Dialog.Error.Text.ContactSupport"
                  )
                )
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dc87138", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc87138","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Authy2fa/AccountAuthentication.vue
// module id = null
// module chunks = 